import * as React from 'react';
import b_ from 'b_';
import moment from 'moment';
import { compose } from 'recompose';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import { Countdown } from './Countdown';

import './index.scss';

interface Props {
  template: 'landing' | 'sellModal';
  from: string;
  to: string;
  onExceed?: () => void;
}

type Enhanced = Props & InjectedTranslateProps;

const enhance = compose<Enhanced, Props>(translate);

const ExchangeWorkingCountdown: React.SFC<Enhanced> = ({ t, template, from, to, onExceed }) => {
  const b = b_.with(`exchange-working-countdown-for-${template}`);

  const hours = {
    from: moment(from).format('HH:mm'),
    to: moment(to).format('HH:mm'),
  };

  const NYHours = {
    from: moment(from).utcOffset(-4).format('HH:mm'),
    to: moment(to).utcOffset(-4).format('HH:mm'),
  };

  return (
    <div className={b()}>
      <div className={b('countdown')}>
        <div>{t('Until the opening of the exchange')}</div>
        <div className={b('timer')}>
          <Countdown to={from} onExceed={onExceed} />
        </div>
      </div>
      <div className={b('text')}>
        {t('The Exchange open {{ from }} to {{ to }} in your time zone', hours)}{' '}
        {t('The Exchange open {{ from }} to {{ to }} at New-York time zone', NYHours)}
      </div>
    </div>
  );
};

export default enhance(ExchangeWorkingCountdown);
